import { DatePicker } from 'antd';
import s from './index.module.css';
import { useState } from 'react';
import dayjs from 'dayjs';
import { CalendarOutlined } from "@ant-design/icons";
import InputWhite from '@pages/Admin/Mailings/Create/InputWhite';
import Button from '../../../UI/Button';

const INPUT_DATE_FORMAT = 'YYYY-MM-DD'
const OUTPUT_DATE_FORMAT = 'DD.MM.YY'

const JournalAddColumn = ({
    data
}) => {
    const [date, setDate] = useState(dayjs(new Date()).format(INPUT_DATE_FORMAT))
    const setCurrentDate = () => {
        setDate(dayjs(new Date()).format(INPUT_DATE_FORMAT))
    }

    const [comment, setComment] = useState('');

    return (<>
        <div className={s.title}>
            Добавить столбец
        </div>
        <div className={s.body}>
            <div className={s.block}>
                <div className={s.text}>
                    <p>Выберите дату нового столбца</p>
                    <DatePicker
                        onChange={date => {
                            date ?
                            setDate(dayjs(date).format(INPUT_DATE_FORMAT)) :
                            setCurrentDate()
                        }}
                        value={dayjs(date, INPUT_DATE_FORMAT)}
                        format={OUTPUT_DATE_FORMAT}
                        className={s.customDatepicker}
                        suffixIcon={<CalendarOutlined />}
                    />
                </div>
                <div className={s.text}>
                    <p>Комментарий</p>
                    <InputWhite
                        className={s.customDatepicker}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </div>
            </div>
            <Button
                newDesign
                className={s.add}
                action={() => data.add({
                    date,
                    comment
                })}
            >Добавить</Button>
        </div>
    </>)
}

export default JournalAddColumn;